import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{page-title (t \"appTitle\")}}\n\n{{outlet}}",{ moduleName: "walden-fast/templates/application.hbs" })